
import React from 'react';
import UserReviewsDisplay from '@/components/reviews/UserReviewsDisplay';

interface UserRatingsProps {
  userId: string;
}

const UserRatings: React.FC<UserRatingsProps> = ({ userId }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 mt-6">
      <h3 className="text-xl font-bold mb-4">Vlerësimet e Përdoruesit</h3>
      <UserReviewsDisplay userId={userId} />
    </div>
  );
};

export default UserRatings;
